// extracted by mini-css-extract-plugin
export default {"card":"Card_card__FYQMH","imageContainer":"Card_imageContainer__oI36k","info":"Card_info__VRTMC","title":"Card_title__5fzwt","desc":"Card_desc__CtSHw"};